const getAdminData = async (axiosPrivate, token) => {
  try {
    const response = await axiosPrivate.get("/admin/adminget", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching admin data:", error);
    throw error;
  }
};

const getRequestInfo = async (axiosPrivate, token) => {
  try {
    const response = await axiosPrivate.get("/admin/requestinfo", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching request info:", error);
    throw error;
  }
};

const addDonationHistory = async (axiosPrivate, donationData, token) => {
  try {
    const response = await axiosPrivate.post(
      "/admin/addDonationHistory",
      donationData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error adding donation history:", error);
    throw error;
  }
};

const getAdminInfo = async (axiosPrivate, token) => {
  try {
    const response = await axiosPrivate.get("/admin/admininfo", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching admin info:", error);
    throw error;
  }
};

const createRequest = async (axiosPrivate, requestData, token) => {
  try {
    const response = await axiosPrivate.post(
      "/admin/addRequests",
      requestData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error creating request:", error);
    throw error;
  }
};

const sendMessage = async (axiosPrivate, messageData, token) => {
  try {
    const response = await axiosPrivate.post("/admin/sendMsg", messageData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    console.error("Error sending message:", error);
    throw error;
  }
};

const editRequest = async (axiosPrivate, requestData, token) => {
  try {
    const response = await axiosPrivate.put("/admin/editRequest", requestData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    console.error("Error editing request:", error);
    throw error;
  }
};

export {
  getAdminData,
  getRequestInfo,
  addDonationHistory,
  getAdminInfo,
  createRequest,
  sendMessage,
  editRequest,
};
